import { atom } from "recoil";

export const SourceTablesWithFilterState = atom<string[]>({
  key: "sourceTablesWithFilterState",
  default: [],
});
